;; Copyright (C) 2018-2019, Doctor Evidence. All rights reserved.

(ns dre.sse
  "Server sent events."
  {:authors ["Michiel Borkent"]}
  (:require
   [cljs.reader :refer [read-string]]
   [clojure.string :as str]
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.components.user-menu.notifications.events :as notifications]
   [dre.config :refer [->sse-api-url ->standard-headers]]
   [dre.network :as-alias network]
   [dre.pages.my-searches.signals.events :as signals]
   [dre.pages.my-searches.tags.events :as tags]
   [dre.widgets.question-answering.events :as qa]
   [dre.util :refer [url-path]]
   [re-frame.core :refer [dispatch] :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]
   [taoensso.timbre :refer [debug warn]]))

(defonce message-count (atom 0))
(defonce websocket-error-count (atom 0))
(defonce sse-error-count (atom 0))
(def reconnect-interval 3000)
;; (def polling-interval 15000)
(def max-errors 5)

(defn ws-url
  [db]
  (-> (->sse-api-url db) (str/replace #"^http" "ws")
      (url-path "ws")))

(declare init!)

(defn on-message [source event fallback-on-close]
  (debug "Received message:" event)
  (case (or (:event/type event) event)
    :sse/ack (do
               (dispatch [::signals/fetch])
               (dispatch [::tags/fetch])
               (dispatch [::notifications/fetch]))
    :sse/close (do
                 (debug "Closing source")
                 (when source (.close source))
                 (when fallback-on-close (fallback-on-close)))
    :signals/new (dispatch [::signals/fetch])
    :notifications/changed (do
                             (dispatch [::tags/fetch])
                             (dispatch [::notifications/fetch]))
    :question-answering/changed (dispatch [::qa/answer-update event])
    :question-answering/highlights (dispatch [::qa/answer-highlights event])
    ;; :annotator/completed (dispatch [::search/determine-refresh])
    (warn "SSE event not recognized" event))
  (swap! message-count inc))

(declare sse-fallback)

;; (rf/reg-event-fx
;;  ::polling-success
;;  [rf/trim-v]
;;  (fn-traced
;;   [_ [{:keys [::fetch-fx/response]}]]
;;   (let [message (:body response)
;;         _ (run! (fn [msg]
;;                   (on-message
;;                    ;; nothing to close
;;                    nil
;;                    (read-string msg)
;;                    ;; nothing to fall back on
;;                    nil))
;;                 message)]
;;     nil)))

;; ;; TODO investigate polling api error
;; (defn polling-fallback [db]
;;   (debug "Falling back on event polling instead of websocket and event source")
;;   (js/setInterval
;;    (fn []
;;      (rf/dispatch [::network/request {:endpoint :sse/polling} {:on-success [::polling-success]}]))
;;    polling-interval))

(defn reconnect! [db]
  (js/setTimeout #(try (if (> @websocket-error-count max-errors)
                         (if (> @sse-error-count max-errors)
                          ;;  (polling-fallback db)
                           (do
                             (reset! websocket-error-count 0)
                             (reset! sse-error-count 0)
                             (init! db))
                           (sse-fallback db))
                         (init! db))
                       (catch js/Error e
                         (debug e)
                         (reconnect! db)))
                 reconnect-interval))

(defn sse-fallback
  [db]
  (debug "Falling back on event source instead of websocket.")
  (let [es (js/EventSource. (url-path (->sse-api-url db) "es") #js {:withCredentials true})]
    (set! (.-onopen es) (fn [_] (reset! sse-error-count 0)))
    (set! (.-onmessage es) (fn [ev] (on-message es (read-string (.-data ev)) nil)))
    (set! (.-onerror es) (fn [_] 
                           (swap! sse-error-count inc)
                           (.close es)
                           (reconnect! db)))))

(defn websocket! [db]
  (let [ws (js/WebSocket. (ws-url db))]
    (set! (.-onopen ws) (fn [_] (reset! websocket-error-count 0)))
    (set! (.-onmessage ws) (fn [ev] (on-message ws (read-string (.-data ev)) (fn [db] 
                                                                               (sse-fallback db)))))
    (set! (.-onclose ws) (fn [_]
                           (swap! websocket-error-count inc)
                           (reconnect! db)))))

(defn init!
  [db]
  (websocket! db))
